import React from "react";
import useElements from "../hooks/useElements";
import { ElementsViewer } from "@wuilt/section-preview";
import { migrateElement } from "./button-migration";
import { ButtonSettingsExtended } from "./button-types";

function Button({ value, className, type, size, customStyle }) {
  const wuiltContext = useElements();
  const element = migrateElement(value.id, value, { type, size });
  const settings = element.settings as ButtonSettingsExtended;

  if (value.hidden) {
    return null;
  }

  return (
    <div id="general-button-text">
      <ElementsViewer.Button
        element={element}
        text={{ [settings.textId!]: settings?.text }}
        wuiltContext={wuiltContext}
        customClassName={className}
        minWidth="max-content"
        customStyle={customStyle}
      />
    </div>
  );
}

export default Button;
